import { createSelector } from 'reselect';
import { formatAnswersHelpers } from '~/components/questions/helpers/format-answers.helpers';

// Since forms now use react-final-form with local state management,
// we retrieve form values from questions.restoredAnswers instead of redux-form state

export const selectFormValues = (state) => state.questions?.restoredAnswers || {};

export const selectYourDetails = createSelector(
  selectFormValues,
  (formState) => formState?.yourDetailsSection,
);

export const selectQuestionsSectionFormValue = createSelector(
  selectFormValues,
  (formState) => formState?.questionsSection || {},
);

export const selectIsRecommendedByAFriend = createSelector(
  selectQuestionsSectionFormValue,
  (questionsSectionFormValues) => {
    const recommendedByAFriendQuestionId = 'q14861';
    return (
      formatAnswersHelpers.getAnswer(questionsSectionFormValues[recommendedByAFriendQuestionId]) ===
      'Yes'
    );
  },
);

// Deprecated selectors - kept for backward compatibility but return empty/default values
// since form errors are now managed locally by react-final-form
export const selectFormSyncErrors = () => ({});
export const selectFormMeta = () => ({});
export const selectQuestionsSectionFormSyncErrors = () => ({});
export const selectQuestionSectionFormMeta = () => ({});
export const selectQuestionSectionErrorNames = () => [];
export const selectTouchedQuestionSectionErrors = () => [];

export const reduxFormSelectors = {
  selectFormValues,
  selectQuestionSectionErrorNames,
  selectTouchedQuestionSectionErrors,
  selectYourDetails,
  selectIsRecommendedByAFriend,
};

export default reduxFormSelectors;
